export enum AccordionSize {
  L = 'l',
  M = 'm',
  S = 's',
}

export enum AccordionVariant {
  PINK = 'pink',
  SAND = 'sand',
  PLAIN = 'plain',
}
